import React, { useState } from "react";
import "./customForm.styles.scss";
import { useDeleteDestination } from "../../api/mutations/destinationMutations";
import { FormTypes } from "../../utils/formFactory";
import DeleteModal from "./DeleteModal";
import Popup from "reactjs-popup";
import { useParams } from "react-router-dom";


const DestinationDeleteModal = () => {
  //   const HandleDestinationUpdate = (id, index) => {
  //     setFormType(FormTypes.UpdateDestination);

  //     const t = { ...dicts[index], destinationId: id };
  //     setInitialFormdata(FormTypes.UpdateDestination, t);
  //     setIsFormOpen(true);
  //   };

  console.log("in deleteeeeee");
  const [isOpenDelete, setIsOpenDelete] = useState(true);
  const {destinationId} = useParams();
  const deleteDestination = useDeleteDestination();

  const HandleIsOpen = () => {
    setIsOpenDelete(!isOpenDelete)
  };

  const onSubmit = (event) => {
    event.preventDefault();

    console.log(`destination id`);
    console.log(destinationId);
    // const data = deleteDestination({destinationId:id});
  };
  
  return (
    <div>
      {/* <Popup
        open={isOpenDelete}
        className="delete-model"
        position="left center"
      > */}
        <DeleteModal
          handleIsOpen={HandleIsOpen}
          title="Delete Destination"
          itemName="Destination"
          onSubmitFunc={onSubmit}
        />
      {/* </Popup> */}
    </div>
  );
};

export default DestinationDeleteModal;
